import React from 'react'
import { icons } from 'app/constants'
import './index.css'

const Index = ({ title, icon = 'user', size = 'l' }) => {
    const ElementIcon = icons[icon]

    return (
        <div className="fallback-listbar-wrapper">
            <div className="fallback-listbar-center-element">
                <ElementIcon size={size} />
                <span>{title}</span>
            </div>
        </div>
    )
}

export default Index
